export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro: string
  bullets: string[]
  closing: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Taekwondo Competition Preparation & Coaching Guide',
    subtitle:
      'Pre-Competition Training, Tactical Preparation, Event-Day Coaching & Post-Competition Review',
    intro:
      'A professional guide for helping instructors structure the competition process. Designed around transferable coaching principles rather than one federation’s rules.',
    bullets: [
      'Competition preparation timelines and tactical preparation',
      'Training priorities and pre-event planning',
      'Warm-up structure and coach communication',
      'Competition-day focus and between-round coaching',
      'Post-event analysis and next-step development',
    ],
    closing: 'Prepare with structure. Coach with clarity. Review with purpose.',
  },
  {
    id: '02',
    title: 'Dojang Class Management & Instructor Leadership System',
    subtitle:
      'Professional strategies for group control, discipline, rotations, transitions and better class flow',
    intro:
      'Knowing Taekwondo is not the same as managing a room full of students. Includes practical class-management scenarios and ready-to-use instructor language.',
    bullets: [
      'Class organization, student attention and drill explanations',
      'Partner rotations and station systems',
      'Mixed-level and large-group organization',
      'Discipline and class transitions',
      'Instructor positioning and training flow',
    ],
    closing: 'Spend less time managing chaos and more time actually coaching.',
  },
  {
    id: '03',
    title: '100 Taekwondo Skill Games, Challenges & Competitive Drills',
    subtitle:
      'Ready-to-use activities for kicking, balance, footwork, reaction, accuracy, coordination and team training',
    intro:
      'Exactly 100 structured Taekwondo activities designed around a real coaching objective. Each activity includes a clear objective, setup, coaching focus and difficulty adaptation.',
    bullets: [
      'Kicking accuracy, balance and footwork',
      'Reaction, timing and coordination',
      'Pad work and partner drills',
      'Team activities',
      'Technical review',
    ],
    closing:
      '100 new ways to make Taekwondo classes more dynamic without turning them into random games.',
  },
  {
    id: '04',
    title: 'Student Motivation, Parent Communication & Retention Guide',
    subtitle:
      'Professional strategies for student engagement, progress conversations, parent communication and long-term retention',
    intro:
      'Great coaching is not only technical. This guide helps instructors communicate progress clearly and professionally.',
    bullets: [
      'Student motivation and progress conversations',
      'Managing plateaus and constructive feedback',
      'Parent communication and expectations',
      'Attendance conversations and re-engagement',
      'Goal setting and long-term student development communication',
    ],
    closing:
      'Make progress visible. Make communication clearer. Keep students moving forward.',
  },
  {
    id: '05',
    title: 'Taekwondo Demonstration Team & Performance Coaching Guide',
    subtitle:
      'Team demonstrations, synchronized technique, performance sequences and public-event preparation',
    intro:
      'A practical guide for instructors who organize demonstrations, exhibitions and performance teams.',
    bullets: [
      'Team roles, demonstration structure and formations',
      'Synchronized techniques, timing and transitions',
      'Kicking sequences and poomsae segments',
      'Rehearsal planning and performance flow',
      'Event-day preparation and performance review',
    ],
    closing: 'Turn individual technique into a structured team performance.',
  },
]
